import { fExecuteAPI } from "../../Server/Apis";

import {
  DBKernObj,
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  getUniqueValues,
} from "../../Utility/Utilitys";

import { vRdxUserInfo, WmsDashboardRo } from "../../Redux/roStore";
import moment from "moment";
import dayjs from "dayjs";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  G1_LoadVersion_GETROW,
  G1_PendingPO_Attributes_GETROW,
  G1_PendingPO_Save_GETROW,
  WMSDashBoard_TransactionDetail,
  G1_POPending_DELETE_GETROW,
  G1_POPending_POST_REVERSE_GETROW,
  G2_PendingPutAwayDetail_LoadDetail_GETROW,
  G5_PickingProgressDetail_LoadDetail_GETROW,
  GetUnbayLoad_Receiver_User_GETROW,
  WMSDashBoard_Summary_GETROW,
  getPurchaseGrnVariance_GETROW,
  G1_PendingPO_ValidateInvExistence_GETROW,
} from "../../Server/ApiV2";
import { IconButton, useMediaQuery } from "@mui/material";
import { createMultiSelectOperator } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { confirmAlert } from "react-confirm-alert";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = LoadingReceipt();

export const ErrorMsg = {
  Type: "",
  VoucherTypeName: "",
  VoucherTypeCode: "",
  RefDate: "",
  VoucherNo: "",
  Version: "",
  PartyCode: "",
  PartyName: "",
  ExpiryDate: "",
  PoNetAmount: "",
  NoOfLineItems: "",
  GRNDate: "",
  InvNo: "",
  InvDate: "",
  AllocateReceiver: "",
  UnloadingBay: "",
  ExpStartTime: "",
  ExpFinishTime: "",
  TotalTimeinMin: "",
  GRNNetAmt: "",
  NoOfItems: "",
  Location: "",
};

export const isMobileAndTab = () => {
  return window.innerWidth <= 800;
};

export const Summary_Columns_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "Transaction", headerName: "Transaction", width: 240 },
  { field: "Count", headerName: "Count", width: 90 },
];
export const G1_PendingPO_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  }, // Added ID column
  {
    field: "VocType",
    headerName: "Voucher Type",
    width: 100,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "VocName",
    headerName: "Voc Name",
    width: 200,
    headerAlign: "center",
    align: "left",
  },
  {
    field: "VocNo",
    headerName: "Voc No",
    width: 110,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "A_RefNo",
    headerName: "Ref No",
    width: 100,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "PostDt",
    headerName: "Post Date",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    width: 90,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "ExpDate",
    headerName: "Exp Date",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    width: 90,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "PartyCode",
    headerName: "Party",
    width: 90,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "PartyName",
    headerName: "Party Name",
    flex: isMobileAndTab ? 0 : 1,
    width: isMobileAndTab && 400,
    headerAlign: "center",
    align: "left",
  },
  {
    field: "POAmount",
    headerName: "Value",
    type: "number",
    width: 80,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "NoofItem",
    headerName: "Items",
    type: "number",
    width: 90,
    headerAlign: "center",
    align: "center",
  },
];

export const G1_PendingRCV_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "VocTyp",
    headerName: "Po.Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "VocName",
    headerName: "PO.Name",
    // flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
    width: 180,
  },
  {
    field: "VocNo",
    headerName: "PO.No",
    // flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
    width: 120,
  },
  {
    field: "SrNo",
    headerName: "Serial Number",
    width: 200,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "PDTuser",
    headerName: "PDT.User",
    width: 250,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LDPay",
    headerName: "Loading.Bay",
    width: 120,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "ExpcTimeStart",
    headerName: "Start.Time",
    width: 90,
    headerAlign: "center",
    align: "center",

    valueFormatter: ({ value }) =>
      moment(value).format("HH:mm") == "Invalid date"
        ? ""
        : moment(value).format("HH:mm"),
    hide: false,
  },
  {
    field: "ExpcTimeEnd",
    headerName: "Time.End",
    width: 90,
    headerAlign: "center",
    align: "center",
    valueFormatter: ({ value }) =>
      moment(value).format("HH:mm") == "Invalid date"
        ? ""
        : moment(value).format("HH:mm"),
    hide: false,
  },
  {
    field: "POLineItems",
    headerName: "Items.Count",
    width: 110,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "POAmt",
    headerName: "PO.Amount",
    width: 110,
    headerAlign: "center",
    align: "center",
    type: "number",
    hide: false,
  },
  {
    field: "InvAmt",
    headerName: "Inv.Amount",
    width: 110,
    headerAlign: "center",
    align: "center",
    type: "number",
    hide: false,
  },
  {
    field: "InvLineItems",
    headerName: "Inv.Line.Items",
    width: 110,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "GrnDocTyp",
    headerName: "GRN.Type",
    width: 120,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "GRNName",
    headerName: "GRN.Type",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "GrnDocNo",
    headerName: "GRN.No",
    width: 150,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "GRNDate",
    headerName: "GRN.Date",
    width: 100,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "GRNAmt",
    headerName: "GRN.Net.Amt",
    width: 100,
    headerAlign: "center",
    align: "center",
    type: "number",
    hide: false,
  },
  {
    field: "PODate",
    headerName: "PO Date",
    width: 100,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: true,
  },
  {
    field: "InvNo",
    headerName: "Inv.No",
    width: 90,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "InvDt",
    headerName: "Invoice.Dt",
    width: 100,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "PDTuserCd",
    headerName: "PDT User Code",
    width: 120,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "LDPayCd",
    headerName: "LD Pay Code",
    width: 120,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
];
export const G1_POVarience_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "GrnDocTyp",
    headerName: "Grn.Doc.Typ",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "GrnVocName",
    headerName: "Grn.Doc.Typ",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "GrnDocNo",
    headerName: "GRN.Doc.No",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "GRNDate",
    headerName: "GRN.Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "GRNAmt",
    headerName: "GRN.Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "PODate",
    headerName: "PO.Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: true,
  },
  {
    field: "InvDt",
    headerName: "Inv.Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: true,
  },
  {
    field: "InvNo",
    headerName: "Invoice Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "VocTyp",
    headerName: "Doc.Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "VocName",
    headerName: "Document",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "VocNo",
    headerName: "Doc.No",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "SrNo",
    headerName: "Serial Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "POLineItems",
    headerName: "PO.No.Items",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "POAmt",
    headerName: "PO.Net.Amt",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "InvAmt",
    headerName: "Inv.Net.Amt",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "InvLineItems",
    headerName: "Inv.No.Items",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "IsRcvngStarted",
    headerName: "Is Receiving Started",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "boolean",
    hide: true,
  },
  {
    field: "IsRcvngCompl",
    headerName: "Is Receiving Complete",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "boolean",
    hide: true,
  },
  {
    field: "IsRcvngPosted",
    headerName: "Is Receiving Posted",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "boolean",
    hide: true,
  },
  {
    field: "IsPosted",
    headerName: "Is Posted",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "boolean",
    hide: true,
  },
];

export const G2_PendingPutAway_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "A_VocTyp",
    headerName: "GRN.Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "VocName",
    headerName: "GRN.Type",
    width: 200,
    headerAlign: "center",
    align: "left",
    hide: false,
    //filterOperators: [createMultiSelectOperator(locationList)],
  },
  {
    field: "A_VocNo",
    headerName: "GRN.No",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_PostDt",
    headerName: "Date",
    width: 100,
    headerAlign: "center",
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
    hide: false,
  },
  {
    field: "A_RefDt",
    headerName: "Date",
    flex: 1,
    headerAlign: "center",
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
    hide: true,
  },

  {
    field: "A_RefNo",
    headerName: "Ref.No",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_Party",
    headerName: "PartyName",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "PartyName",
    headerName: "Party",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },

  {
    field: "ExpcTimeStart",
    headerName: "Expected Time Start",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "A_PayMode",
    headerName: "PayMode",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: false,
  },

  {
    field: "A_PayMode",
    headerName: "PayMode",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "A_Br",
    headerName: "A_Br",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "BrName",
    headerName: "BrName",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "A_Loc",
    headerName: "A_Loc",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "LocName",
    headerName: "Loc",
    width: 150,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "A_TransSrNo",
    headerName: "TransSrNo",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "IsPutAwyAssigned",
    headerName: "Put Away",
    width: 100,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
];
export const G2_PendingPutAway_LoadDetail_ColumnV1 = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "VocTyp",
    headerName: "Voucher Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "VocName",
    headerName: "Voucher Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "VocNo",
    headerName: "Voucher Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "SrNo",
    headerName: "Serial Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "PDTuser",
    headerName: "PDT User",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LDPay",
    headerName: "LD Pay",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "ExpcTimeStart",
    headerName: "Expected Time Start",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "ExpcTimeEnd",
    headerName: "Expected Time End",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "POLineItems",
    headerName: "PO Line Items",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "POAmt",
    headerName: "PO Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "InvAmt",
    headerName: "Invoice Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "InvLineItems",
    headerName: "Invoice Line Items",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "GrnDocTyp",
    headerName: "GRN Document Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "GRNName",
    headerName: "GRN Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "GrnDocNo",
    headerName: "GRN Document Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "GRNDate",
    headerName: "GRN Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "GRNAmt",
    headerName: "GRN Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "PODate",
    headerName: "PO Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "InvNo",
    headerName: "Invoice Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "InvDt",
    headerName: "Invoice Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "PDTuserCd",
    headerName: "PDT User Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LDPayCd",
    headerName: "LD Pay Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
];

export const G3_PendingPicking_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "A_VocTyp",
    headerName: "Voucher Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "VocName",
    headerName: "Voucher Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_VocNo",
    headerName: "Voucher Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_RefNo",
    headerName: "Reference Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_PostDt",
    headerName: "Post Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "A_Party",
    headerName: "Party Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "PartName",
    headerName: "Party Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_Loc",
    headerName: "Location Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LocName",
    headerName: "Location Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_NetAmt",
    headerName: "Net Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "A_TransSrNo",
    headerName: "Transaction Serial Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
];

export const G4_PendingEnter_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "A_VocTyp",
    headerName: "Voucher Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "VocName",
    headerName: "Voucher Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_VocNo",
    headerName: "Voucher Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_PostDt",
    headerName: "Post Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "A_Party",
    headerName: "Party Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "PartName",
    headerName: "Party Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_Loc",
    headerName: "Location Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LocName",
    headerName: "Location Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_NetAmt",
    headerName: "Net Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "A_TransSrNo",
    headerName: "Transaction Serial Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
];
export const G4_SalesInvoice_LoadDetail_Column = (isPicking, fIconClick) => [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  ...(isPicking
    ? [
        {
          field: "user",
          headerName: "User",
          flex: 0.5,
          headerAlign: "center",
          align: "center",
          renderCell: (params) => {
            console.log(params);
            return (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  fIconClick?.(params);
                }}
              >
                <ManageAccountsIcon />
              </IconButton>
            );
          },
        },
      ]
    : []),
  {
    field: "A_VocTyp",
    headerName: "Doc.Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "VocName",
    headerName: "Doc.Type",
    width: 200,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_VocNo",
    headerName: "Doc.No",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_RefNo",
    headerName: "Ref.No",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_PostDt",
    headerName: "Date",
    width: 100,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "A_Party",
    headerName: "Party",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "PartName",
    headerName: "Party Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_Loc",
    headerName: "Loc",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "LocName",
    headerName: "Location",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_NetAmt",
    headerName: "Net.Amt",
    width: 90,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "A_TransSrNo",
    headerName: "A_TransSrNo",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
];
export const G5_PickingProgress_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "A_VocTyp",
    headerName: "Voucher Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "VocName",
    headerName: "Voucher Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_VocNo",
    headerName: "Voucher Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_RefNo",
    headerName: "Reference Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "A_VocDt",
    headerName: "Voucher Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "A_Loc",
    headerName: "Location Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "PartName",
    headerName: "Party Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LocName",
    headerName: "Location Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "NoColumnName",
    headerName: "Unnamed Column",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  }, // Placeholder for the unnamed column
  {
    field: "A_TransSrNo",
    headerName: "Transaction Serial Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
];
export const G2_PendingPutAwayDetail_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "U_Lvl",
    headerName: "Level Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "LvlName",
    headerName: "Level",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "U_Type",
    headerName: "Type",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "U_Pallet",
    headerName: "Pallet",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "U_User",
    headerName: "User Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "UserName",
    headerName: "User Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "Completed",
    headerName: "Completed",
    width: 100,
    headerAlign: "center",
    align: "center",
    // type: "boolean",
    hide: false,
  },
  {
    field: "U_VocTyp",
    headerName: "Voucher Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "U_VocNo",
    headerName: "Voucher Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "A_TransSrNo",
    headerName: "Transaction Serial Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
];

export const G5_PickingProgressDetail_LoadDetail_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "H_AisleCd",
    headerName: "Aisle Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "AisleName",
    headerName: "Aisle",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "H_Level",
    headerName: "Level Code",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "LevelName",
    headerName: "Level Name",
    width: 100,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "H_UserCd",
    headerName: "User Code",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "UserName",
    headerName: "User Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "Status",
    headerName: "Status",
    width: 90,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
];

export const G1_LoadVersion_Column = [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "PDTuser",
    headerName: "PDT User",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "LDPay",
    headerName: "LD Pay",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "ExpcTimeStart",
    headerName: "Expected Time Start",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "ExpcTimeEnd",
    headerName: "Expected Time End",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "InvAmt",
    headerName: "Invoice Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    type: "number",
    hide: false,
  },
  {
    field: "InvLineItems",
    headerName: "Invoice Line Items",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "GRNDate",
    headerName: "GRN Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "IsRcvngStarted",
    headerName: "Is Receiving Started",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "boolean",
    hide: false,
  },
  {
    field: "IsPosted",
    headerName: "Is Posted",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "boolean",
    hide: false,
  },
  {
    field: "InvNo",
    headerName: "Invoice Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "InvDt",
    headerName: "Invoice Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "date",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),

    hide: false,
  },
  {
    field: "Party",
    headerName: "Party",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "CUSTFIELD6",
    headerName: "Custom Field 6",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "SRVocTyp",
    headerName: "SR Voucher Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "SRVocTypName",
    headerName: "SR Voucher Type Name",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
  {
    field: "SRVocNo",
    headerName: "SR Voucher Number",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
  },
];

export const fKeyLoadingReceipt = (event) => {
  const form = document.getElementById("WmsDashboardHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

export const fKeyLoadingReceiptContent = (event) => {
  const form = document.getElementById("WmsDashboardContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

export const fValidationHead_Client = (vRdxHead) => {
  let iRes = true;
  if (
    vRdxHead.PartyCode === "" ||
    vRdxHead.PartyCode === null ||
    vRdxHead.PartyCode === undefined
  ) {
    fAlertToast("FAILED", "Party Code should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.PartyName === "" ||
    vRdxHead.PartyName === null ||
    vRdxHead.PartyName === undefined
  ) {
    fAlertToast("FAILED", "Party Name should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.Location === "" ||
    vRdxHead.Location === null ||
    vRdxHead.Location === undefined
  ) {
    fAlertToast("FAILED", "Location should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.GRNDate === "" ||
    vRdxHead.GRNDate === null ||
    vRdxHead.GRNDate === undefined ||
    vRdxHead.GRNDate == "Invalid Date"
  ) {
    fAlertToast("FAILED", "Enter valid GRN date");
    iRes = false;
  }

  if (
    vRdxHead.InvNo === "" ||
    vRdxHead.InvNo === null ||
    vRdxHead.InvNo === undefined
  ) {
    fAlertToast("FAILED", "InvNo should not be empty");

    iRes = false;
  }

  if (
    vRdxHead.InvDate === "" ||
    vRdxHead.InvDate === null ||
    vRdxHead.InvDate === undefined ||
    vRdxHead.InvDate == "Invalid Date"
  ) {
    fAlertToast("FAILED", "Enter valid Invoice date");
    iRes = false;
  }

  if (
    vRdxHead.Type === "" ||
    vRdxHead.Type === null ||
    vRdxHead.Type === undefined
  ) {
    fAlertToast("FAILED", "Type should not be empty");

    iRes = false;
  }
  if (
    vRdxHead.UnloadingBay === "" ||
    vRdxHead.UnloadingBay === null ||
    vRdxHead.UnloadingBay === undefined
  ) {
    fAlertToast("FAILED", "UnloadingBay should not be empty");

    iRes = false;
  }
  if (
    vRdxHead.AllocateReceiver === "" ||
    vRdxHead.AllocateReceiver === null ||
    vRdxHead.AllocateReceiver === undefined
  ) {
    fAlertToast("FAILED", "AllocateReceiver should not be empty");

    iRes = false;
  }

  if (
    (vRdxHead.GRNNetAmt === "" ||
      vRdxHead.GRNNetAmt === null ||
      vRdxHead.GRNNetAmt === undefined ||
      vRdxHead.GRNNetAmt == 0) &&
    DBKernObj("WMINV03_UNITRATE_VLDT")
  ) {
    fAlertToast("FAILED", "Enter GRN amount");

    iRes = false;
  }
  if (
    (vRdxHead.NoOfItems === "" ||
      vRdxHead.NoOfItems === null ||
      vRdxHead.NoOfItems === undefined ||
      vRdxHead.NoOfItems == 0) &&
    DBKernObj("WMINV03_UNITRATE_VLDT")
  ) {
    fAlertToast("FAILED", "Enter NoOfItems");

    iRes = false;
  }
  if (
    (vRdxHead.TotalTimeinMin === "" ||
      vRdxHead.TotalTimeinMin === null ||
      vRdxHead.TotalTimeinMin === undefined ||
      vRdxHead.TotalTimeinMin <= 0) &&
    DBKernObj("WMINV03_UNITRATE_VLDT")
  ) {
    fAlertToast("FAILED", "Finshing time should be greater than start time");

    iRes = false;
  }

  return iRes;
};

export const fLoad_Grid = async (setDetailGridData) => {
  let iSIDetailObj = {
    v_Typ: "A",
    v_Data: "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
  const iSIDetailResult = {};
  if (iSIDetailResult?.status == 200) {
    if (iSIDetailResult.data.ResultSet.length > 0) {
      let GridID = iSIDetailResult.data.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setDetailGridData(GridID);
    } else {
      setDetailGridData([]);
    }
  }
};

export const G2_PendingPutAwayDetail_LoadDetail = async (
  setRow,
  VocNo = "",
  VocTyp = ""
) => {
  var vObj = {
    VocTyp: VocTyp,
    VocNo: VocNo,
  };
  const Resp = await G2_PendingPutAwayDetail_LoadDetail_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    let row = Resp.data.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setRow(row);
    return Resp?.data?.ResultSet;
  } else {
    return setRow([]);
  }
};
//HEAD LOADING API
//Invoice Existence validation on Pending PO Api

export const fValidateInvExistence = async (
  vRdxWmsHead,
  sDrawerTitle,
  setHead
) => {
  let obj = {
    InvNo: vRdxWmsHead.InvNo,
    PartyCd: vRdxWmsHead.PartyCode,
    VocTyp: vRdxWmsHead.VoucherTypeCode,
    VocNo: vRdxWmsHead.VoucherNo,
  };

  const resp = await G1_PendingPO_ValidateInvExistence_GETROW(obj);

  if (resp?.status === 200) {
    const resultSet = resp?.data?.ResultSet || [];

    if (resultSet.length === 0) {
      await fSave(vRdxWmsHead, sDrawerTitle, setHead);
      return;
    }

    const message = resultSet[0]?.Message;

    confirmAlert({
      title: "Confirmation",
      message: message,
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            await fSave(vRdxWmsHead, sDrawerTitle, setHead);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: false,
    });
  }
};

//API SaveSIHead
export const fSave = async (HeadObject, sDrawerTitle, setHead) => {
  let vSaveSIHeadObj = {
    v_VocTyp: HeadObject.VoucherTypeCode,
    v_VocNo: HeadObject.VoucherNo,
    v_SrNo: HeadObject.Version,
    v_PDTuser: HeadObject.AllocateReceiver,
    v_LDPay: HeadObject.UnloadingBay,
    v_ExpcTimeStart: HeadObject.ExpStartTime,
    v_ExpcTimeEnd: HeadObject.ExpFinishTime,
    v_POLineItems: HeadObject.NoOfLineItems,
    v_POAmt: HeadObject.PoNetAmount,
    v_InvAmt: HeadObject.GRNNetAmt,
    v_InvLineItems: HeadObject.NoOfItems,
    v_GRNDate: moment(HeadObject.GRNDate).format("MM/DD/YYYY"),
    v_InvNo: HeadObject.InvNo,
    v_InvDt: moment(HeadObject.InvDate).format("MM/DD/YYYY"),
    v_Party: HeadObject.PartyCode,
    v_CUSTFIELD6: HeadObject.Type,
    v_TrnTyp: sDrawerTitle.trntype,
    v_SRVocTyp: HeadObject.A_RefTyp,
    v_SRVocNo: HeadObject.A_RefDocNo,
    v_Loc: HeadObject.Location,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const Resp = await G1_PendingPO_Save_GETROW(
    fcheck_null_undefine_replace_empty(FinalObj)
  );

  if (Resp?.status === 200) {
    setHead((obj) => ({
      ...obj,
      VoucherNo: Resp.data.ResultSet.VocNo,
    }));
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};

export const GetLoad = async (setSummaryRow) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    v_UserCd: vRdxUserInfoObj.UserID,
    v_UserGrp: vRdxUserInfoObj.UserGroupCode,
  };
  const Resp = await WMSDashBoard_Summary_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    const newObj = {};
    for (const key in Resp?.data?.ResultSet) {
      if (Object.prototype.hasOwnProperty.call(Resp?.data?.ResultSet, key)) {
        // Map over each array and add unique id to each item
        newObj[key] = Resp?.data?.ResultSet[key].map((item, i) => ({
          ...item,
          id: i + 1,
        }));
      }
    }
    setSummaryRow(newObj);
    return Resp?.data?.ResultSet;
  } else {
    return {};
  }
};

export const Detail_Loading = async (Header = "", TrnTyp = "") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    Header: Header || "",
    TrnTyp: TrnTyp || "",
    UserCd: vRdxUserInfoObj.UserID,
    // UserGrp: vRdxUserInfoObj.UserGroupCode,
  };
  const Resp = await WMSDashBoard_TransactionDetail(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    let row = Resp.data.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));

    return row;
  } else {
    return [];
  }
};
export const getPurchaseGrnVariance = async (setRow, row) => {
  var vObj = {
    v_POVocTyp: row.VocTyp || "",
    v_POVocNo: row.VocNo || "",
    v_GRNVocTyp: row.GrnDocTyp || "",
    v_GRNVocNo: row.GrnDocNo || "",
  };
  const Resp = await getPurchaseGrnVariance_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    let row = Resp.data.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setRow(row);
    return Resp?.data?.ResultSet;
  } else {
    return setRow([]);
  }
};
export const G5_PickingProgressDetail_LoadDetail = async (
  setRow,
  VocNo = "",
  VocTyp = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    v_VocTyp: VocTyp,
    v_VocNo: VocNo,
  };
  const Resp = await G5_PickingProgressDetail_LoadDetail_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    let row = Resp.data.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setRow(row);
    return Resp?.data?.ResultSet;
  } else {
    return setRow([]);
  }
};
export const G1_PendingPO_Attributes = async (
  setRow,
  VocNo = "",
  VocTyp = "",
  Trntyp = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    Trntyp: Trntyp,
    VocTyp: VocTyp,
    VocNo: VocNo,
    UserCd: vRdxUserInfoObj.UserID,
  };
  const Resp = await G1_PendingPO_Attributes_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    setRow(Resp?.data?.ResultSet);
    return Resp?.data?.ResultSet;
  } else {
    setRow({});
    return {};
  }
};
export const G1_LoadVersion = async (
  set,
  VoucherTypeCode = "",
  VoucherNo = "",
  Version = "",
  handleTimeDifference = () => {}
) => {
  var vObj = {
    v_VocTyp: VoucherTypeCode,
    v_VocNo: VoucherNo,
    v_SrNo: Version,
  };
  const Resp = await G1_LoadVersion_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    set((prev) => ({
      ...prev,
      ExpStartTime: dayjs().format("hh:mm:ss"),
      ExpFinishTime: dayjs().format("hh:mm:ss"),
      TotalTimeinMin: 0,
      GRNNetAmt: 0,
      NoOfItems: 0,
      UnloadingBay: DBKernObj("WMINV03_UNITRATE_VLDT") ? "" : "",
      UnloadingBayName: DBKernObj("WMINV03_UNITRATE_VLDT") ? "" : "",
      AllocateReceiver: "",
      AllocateReceiverName: "",
      GRNDate: new Date(),
      InvNo: "",
      InvDate: new Date(),
      Location: "",
      btnPost: true,
      btnSave: true,
      btnReverse: false,
      btnDelete: true,
    }));
    if (Resp?.data?.ResultSet.length > 0) {
      set((prev) => ({
        ...prev,
        // ExpStartTime: dayjs(Resp?.data?.ResultSet[0].ExpcTimeStart).format('HH:mm:ss'),
        // ExpFinishTime: dayjs(Resp?.data?.ResultSet[0].ExpcTimeEnd).format('HH:mm:ss'),
        ExpStartTime:
          Resp?.data?.ResultSet[0].ExpcTimeStart.split("T")[1].split(".")[0] ||
          0,
        ExpFinishTime:
          Resp?.data?.ResultSet[0].ExpcTimeEnd.split("T")[1].split(".")[0] || 0,
        TotalTimeinMin: handleTimeDifference(
          Resp?.data?.ResultSet[0].ExpcTimeStart.split("T")[1].split(".")[0] ||
            0,
          Resp?.data?.ResultSet[0].ExpcTimeEnd.split("T")[1].split(".")[0] || 0
        ),
        GRNNetAmt: Resp?.data?.ResultSet[0].InvAmt || 0,
        NoOfItems: Resp?.data?.ResultSet[0].InvLineItems || 0,
        UnloadingBay: Resp?.data?.ResultSet[0].LDPay || "",
        AllocateReceiver: Resp?.data?.ResultSet[0].PDTuser || "",
        GRNDate: Resp?.data?.ResultSet[0].GRNDate || "",
        Type: Resp?.data?.ResultSet[0].CUSTFIELD6 || "",
        InvDate: Resp?.data?.ResultSet[0].InvDt || "",
        InvNo: Resp?.data?.ResultSet[0].InvNo || 0,
        A_RefTyp: Resp?.data?.ResultSet[0].SRVocTyp || "",
        A_RefName: Resp?.data?.ResultSet[0].SRVocTypName || "",
        A_RefDocNo: Resp?.data?.ResultSet[0].SRVocNo || "",
        Location: Resp?.data?.ResultSet[0].Loc || "",
      }));
      if (Resp?.data?.ResultSet[0].IsPosted == "Y") {
        set((prev) => ({
          ...prev,
          btnPost: false,
          btnSave: false,
          btnReverse: true,
          btnDelete: false,
        }));
      } else {
        set((prev) => ({
          ...prev,
          btnPost: true,
          btnSave: true,
          btnReverse: false,
          btnDelete: true,
        }));
      }
    }

    return Resp?.data?.ResultSet;
  } else {
    return [];
  }
};
export const G1_POPending_POST_REVERSE = async (
  Status = "POST",
  HeadObject
) => {
  var vObj = {
    Status: Status,
    v_VocTyp: HeadObject?.VoucherTypeCode,
    v_VocNo: HeadObject?.VoucherNo,
    v_SrNo: HeadObject?.Version,
  };
  const Resp = await G1_POPending_POST_REVERSE_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    fAlertToast("SUCCESS", "Successfully Deleted");
    return Resp?.data?.ResultSet;
  }
};

export const G1_POPending_DELETE = async (HeadObject) => {
  var vObj = {
    v_VocTyp: HeadObject?.VoucherTypeCode,
    v_VocNo: HeadObject?.VoucherNo,
    v_SrNo: HeadObject?.Version,
  };
  const Resp = await G1_POPending_DELETE_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    fAlertToast("SUCCESS", "Successfully Deleted");
    return Resp?.data?.ResultSet;
  }
};
export const GetUnbayLoad_Receiver_User = async (
  setRow,
  v_LDBay = "",
  v_Date = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    v_LDBay: v_LDBay,
    v_Date: v_Date,
    v_user: vRdxUserInfoObj.UserID,
  };
  const Resp = await GetUnbayLoad_Receiver_User_GETROW(
    fcheck_null_undefine_replace_empty(vObj)
  );
  if (Resp?.status === 200) {
    let row = Resp.data.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setRow(row);
    return Resp?.data?.ResultSet;
  } else {
    return setRow([]);
  }
};

const getG2_PendingPutAway_LoadDetail_Columns = ({
  vocNoList,
  vocNameList,
  refNoList,
  partyNameList,
}) => [
  {
    field: "id",
    headerName: "ID",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "A_VocTyp",
    headerName: "GRN.Type",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "VocName",
    headerName: "GRN.Type",
    width: 200,
    headerAlign: "center",
    align: "left",
    hide: false,
    // ✅ multi-select filter for VocName
    filterOperators: [createMultiSelectOperator(vocNameList)],
  },
  {
    field: "A_VocNo",
    headerName: "GRN.No",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
    // ✅ multi-select filter for A_VocNo
    filterOperators: [createMultiSelectOperator(vocNoList)],
  },
  {
    field: "A_PostDt",
    headerName: "Date",
    width: 100,
    headerAlign: "center",
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") === "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
    hide: false,
  },
  {
    field: "A_RefDt",
    headerName: "Date",
    flex: 1,
    headerAlign: "center",
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") === "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
    hide: true,
  },
  {
    field: "A_RefNo",
    headerName: "Ref.No",
    width: 150,
    headerAlign: "center",
    align: "left",
    hide: false,
    filterOperators: [createMultiSelectOperator(refNoList)],
  },
  {
    field: "A_Party",
    headerName: "PartyName",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: true,
  },
  {
    field: "PartyName",
    headerName: "Party",
    flex: 1,
    headerAlign: "center",
    align: "left",
    hide: false,
    // ✅ multi-select filter for LocName
    filterOperators: [createMultiSelectOperator(partyNameList)],
  },
  {
    field: "ExpcTimeStart",
    headerName: "Expected Time Start",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "A_PayMode",
    headerName: "PayMode",
    flex: 1,
    headerAlign: "center",
    align: "center",
    hide: false,
  },
  {
    field: "A_Br",
    headerName: "A_Br",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "BrName",
    headerName: "BrName",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "A_Loc",
    headerName: "A_Loc",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "LocName",
    headerName: "Loc",
    width: 150,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
  {
    field: "A_TransSrNo",
    headerName: "TransSrNo",
    flex: 1,
    headerAlign: "center",
    align: "right",
    hide: true,
  },
  {
    field: "IsPutAwyAssigned",
    headerName: "Put Away",
    width: 100,
    headerAlign: "center",
    align: "right",
    hide: false,
  },
];

// Example component using your rows
export default function PendingPutAwayGrid({ rows, onRowClick }) {
  const putAwayData = rows["Put-away in progress"]?.data || [];

  const vocNoList = useMemo(
    () => getUniqueValues(putAwayData, "A_VocNo"),
    [putAwayData]
  );
  const vocNameList = useMemo(
    () => getUniqueValues(putAwayData, "VocName"),
    [putAwayData]
  );
  const refNoList = useMemo(
    () => getUniqueValues(putAwayData, "A_RefNo"),
    [putAwayData]
  );
  const partyNameList = useMemo(
    () => getUniqueValues(putAwayData, "PartyName"),
    [putAwayData]
  );

  const columns = useMemo(
    () =>
      getG2_PendingPutAway_LoadDetail_Columns({
        vocNoList,
        vocNameList,
        refNoList,
        partyNameList,
      }),
    [vocNoList, vocNameList, partyNameList]
  );

  return (
    <div style={{ height: 600, width: "100%" }}>
      <DataGridPro
        rows={putAwayData}
        columns={columns}
        rowHeight={30}
        headerHeight={40}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0
            ? "mui-even-row"
            : "mui-odd-row"
        }
        sx={{
          border: 1,
          borderColor: "primary.light",
        }}
        onRowDoubleClick={(e) => {
          onRowClick(e);
        }}
        getRowId={(row) => row.id}
        disableRowSelectionOnClick
        checkboxSelection={false}
      />
    </div>
  );
}
